export default __webpack_public_path__ + "static/media/PresidenteClosed.bb6817f0.jpg";